export default function Videos() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="videos" className="bg-[#080808] py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white leading-tight max-w-3xl mx-auto">
            Antes de entrar, mira exactamente{' '}
            <span className="text-[#00FF88]">cómo funciona</span> tu nuevo ecosistema por dentro.
          </h2>
          <div className="mt-4 w-16 h-1 bg-gradient-to-r from-[#00FF88] to-[#FF6B35] rounded-full mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <span className="text-2xl">📦</span>
              <h3 className="text-white font-black text-lg md:text-xl tracking-wide">STOCK SIMPLE</h3>
              <span className="ml-auto bg-[#00FF88]/10 border border-[#00FF88]/30 text-[#00FF88] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                Sistema 1
              </span>
            </div>
            <div className="relative w-full aspect-video rounded-xl overflow-hidden">
              <iframe
                src="https://player.vimeo.com/video/1177367204?badge=0&autopause=0&player_id=0&app_id=58479"
                frameBorder={0}
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                allowFullScreen
                title="Stock Simple - Demo"
                className="absolute inset-0 w-full h-full rounded-xl"
              ></iframe>
            </div>
            <p className="text-gray-500 text-sm text-center">
              Gestión de inventario en tiempo real, alertas y reportes visuales.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <span className="text-2xl">💰</span>
              <h3 className="text-white font-black text-lg md:text-xl tracking-wide">BUDGETTRACK</h3>
              <span className="ml-auto bg-[#FF6B35]/10 border border-[#FF6B35]/30 text-[#FF6B35] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                Sistema 2
              </span>
            </div>
            <div className="relative w-full aspect-video rounded-xl overflow-hidden">
              <iframe
                src="https://player.vimeo.com/video/1159768753?badge=0&autopause=0&player_id=0&app_id=58479"
                frameBorder={0}
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                allowFullScreen
                title="Budgettrack - Demo"
                className="absolute inset-0 w-full h-full rounded-xl"
              ></iframe>
            </div>
            <p className="text-gray-500 text-sm text-center">
              Control de presupuesto, detección de fugas y gráficos automáticos.
            </p>
          </div>
        </div>

        <div className="mt-14 text-center">
          <p className="text-gray-400 text-sm md:text-base">
            ¿Ya viste el poder del ecosistema?{' '}
            <button
              onClick={() => scrollTo('bonos')}
              className="text-[#00FF88] font-bold hover:underline cursor-pointer"
            >
              Consíguelo ahora por $12 al año →
            </button>
          </p>
        </div>
      </div>
    </section>
  );
}
